import api from './api';

const userService = {
  create: async (userData) => {
    const response = await api.post('/api/users', userData);
    return response.data;
  },

  list: async () => {
    const response = await api.get('/api/users');
    return response.data;
  },

  update: async (userId, userData) => {
    const response = await api.put(`/api/users/${userId}`, userData);
    return response.data;
  },

  resetPassword: async (userId) => {
    const response = await api.put(`/api/users/${userId}/password-reset`);
    return response.data;
  },
};

export default userService;
